import { useSuspenseQuery } from '@tanstack/react-query';
import { fetchLibrarySetupStatus } from 'api/widgets';
import { useLocalStorage } from 'contexts/useLocalStorage';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { widgetQueryKeys } from 'queries/widget-query-keys';

const useWidgetLibraryStatus = () => {
    const { accountId } = useCurrentAccount();
    const { skipWidgetLibraryInstallation, setSkipWidgetLibraryInstallation } = useLocalStorage(
        state => {
            return {
                skipWidgetLibraryInstallation: state.skipWidgetLibraryInstallation,
                setSkipWidgetLibraryInstallation: state.setSkipWidgetLibraryInstallation,
            };
        },
    );

    const { data: hasWidgetsLibraryInstalled = false } = useSuspenseQuery({
        queryKey: widgetQueryKeys.libraryStatus(accountId),
        queryFn: () => fetchLibrarySetupStatus({ accountId }),
        select: data => {
            return data.has_widgets_library_installed;
        },
        refetchInterval: 10000,
    });

    return {
        hasWidgetsLibraryInstalled,
        showWidgets: hasWidgetsLibraryInstalled || skipWidgetLibraryInstallation,
        skipWidgetLibraryInstallation,
        setSkipWidgetLibraryInstallation,
    };
};

export { useWidgetLibraryStatus };
